(() => {
  const MQ = '(max-width: 749px)';

  function init(wrap) {
    if (!wrap || wrap.dataset.rgfBound === '1') return;
    wrap.dataset.rgfBound = '1';

    const track = wrap.querySelector('.rgf-grid');
    const controls = wrap.querySelector('.rgf-carousel__controls');
    const curEl = wrap.querySelector('[data-rgf-current]');
    const totEl = wrap.querySelector('[data-rgf-total]');
    const prevBtn = wrap.querySelector('.rgf-carousel__controls .slider-button--prev');
    const nextBtn = wrap.querySelector('.rgf-carousel__controls .slider-button--next');
    if (!track) return;

    let looping = false;
    let scrollTimer = 0;

    const realCards = () => [...track.querySelectorAll('.rgf-card:not([data-rgf-clone])')];

    const nearestCard = (cards) => {
      const x = track.scrollLeft;
      let best = cards[0];
      let bestDist = Infinity;
      for (const c of cards) {
        const d = Math.abs(c.offsetLeft - x);
        if (d < bestDist) {
          bestDist = d;
          best = c;
        }
      }
      return best;
    };

    const currentIndex = () => {
      const reals = realCards();
      if (!reals.length) return 0;
      return Math.max(0, reals.indexOf(nearestCard(reals)));
    };

    const updateCounter = () => {
      if (!curEl) return;
      curEl.textContent = String(currentIndex() + 1);
    };

    const jumpTo = (card, behavior = 'auto') => {
      if (!card) return;
      looping = true;
      track.scrollTo({ left: card.offsetLeft, behavior });
      const done = () => {
        looping = false;
        updateCounter();
      };
      if (behavior === 'smooth') {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(done, 320);
      } else {
        requestAnimationFrame(done);
      }
    };

    const goBy = (delta) => {
      if (!window.matchMedia(MQ).matches) return;
      const reals = realCards();
      if (reals.length < 2) return;
      const idx = currentIndex();
      let next = idx + delta;
      if (next < 0) next = reals.length - 1;
      else if (next >= reals.length) next = 0;
      jumpTo(reals[next], 'smooth');
    };

    const onSettle = () => {
      if (looping || !window.matchMedia(MQ).matches) return;
      const cards = [...track.querySelectorAll('.rgf-card')];
      if (cards.length < 3) return;
      const active = nearestCard(cards);
      if (!active) return;
      if (active.dataset.rgfClone === 'end') {
        jumpTo(realCards()[0]);
        return;
      }
      if (active.dataset.rgfClone === 'start') {
        const reals = realCards();
        jumpTo(reals[reals.length - 1]);
        return;
      }
      updateCounter();
    };

    const teardown = () => {
      track.querySelectorAll('[data-rgf-clone]').forEach((n) => n.remove());
      wrap.classList.remove('rgf-wrap--carousel');
      if (controls) controls.hidden = true;
      track.scrollLeft = 0;
    };

    const setup = () => {
      teardown();
      if (!window.matchMedia(MQ).matches) return;

      const originals = realCards();
      if (originals.length < 2) return;

      wrap.classList.add('rgf-wrap--carousel');
      if (controls) controls.hidden = false;
      if (totEl) totEl.textContent = String(originals.length);

      const firstClone = originals[0].cloneNode(true);
      firstClone.dataset.rgfClone = 'end';
      firstClone.setAttribute('aria-hidden', 'true');
      const lastClone = originals[originals.length - 1].cloneNode(true);
      lastClone.dataset.rgfClone = 'start';
      lastClone.setAttribute('aria-hidden', 'true');

      track.insertBefore(lastClone, originals[0]);
      track.appendChild(firstClone);

      jumpTo(originals[0]);
      updateCounter();
    };

    const onScroll = () => {
      if (!window.matchMedia(MQ).matches) return;
      updateCounter();
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onSettle, 90);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', onSettle);
    if (prevBtn) prevBtn.addEventListener('click', () => goBy(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => goBy(1));

    const mq = window.matchMedia(MQ);
    if (mq.addEventListener) mq.addEventListener('change', setup);
    else mq.addListener(setup);

    setup();
    window.addEventListener('load', () => {
      if (window.matchMedia(MQ).matches) {
        const reals = realCards();
        if (reals[0]) jumpTo(reals[0]);
      }
    });
  }

  const boot = () => {
    document.querySelectorAll('[data-rgf-carousel]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
